export default "__VITE_ASSET__CXKG63R6__"